function extractNumber(str = "") {
  return parseInt(str.replace(/\D/g, ""), 10)
}
export default extractNumber
